import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import {ASML_SUB_COMPONENT_ROUTES} from "../../util/RouteConstants";
import SelectLayout, {NavigationRoutes} from "../../util/SelectLayout";

class AsmlSubComponentSelectPage extends Component {
    render() {
        return (
            <Column>
                <SelectLayout routes={ASML_SUB_COMPONENT_ROUTES.sort((a,b) => {
                    return a.name.localeCompare(b.name);
                })} location={this.props.location} history={this.props.history} isComponentTypeSelect={"true"}/>
                <NavigationRoutes routes={ASML_SUB_COMPONENT_ROUTES}/>
            </Column>
        )
    }
}

export default AsmlSubComponentSelectPage


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/AsmlSubComponentSelectPage.js